
import React from 'react';

const Hero: React.FC = () => {
  return (
    <div className="relative pt-32 pb-12 px-8 text-center overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-blue-600/10 blur-[120px] -z-10 rounded-full"></div>
      
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass border border-blue-500/20 text-blue-400 text-xs font-bold uppercase tracking-widest mb-4">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          India's #1 Car Quote Negotiator
        </div>
        
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-black leading-[1.1] tracking-tight">
          SAY NO TO <br />
          <span className="accent-gradient bg-clip-text text-transparent italic">DEALER MARKUPS.</span>
        </h1>
        
        <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed">
          Upload any official dealership quote. <span className="text-white font-bold">dealmycar</span> guarantees to beat it by at least <span className="text-white font-bold underline decoration-blue-500 underline-offset-4">1% extra discount</span>.
        </p>

        <div className="pt-6 animate-bounce opacity-40">
           <svg className="w-6 h-6 mx-auto text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
           </svg>
        </div>
      </div>
    </div>
  );
};

export default Hero;
